import { LinkTabProps, Tab } from './types';

export const getProjectTabLinks = ({ recordId, path, currentUser }: LinkTabProps): Tab[] => {
  const tabs: Tab[] = [
    {
      label: 'Overview',
      to: (recordId) ? `/dashboard/projects/${recordId}/overview` : '/dashboard/projects/new',
    },
  ];

  const isDevMode = process.env.REACT_APP_BUILD_ENV === 'development';

  if (path.indexOf('/projects/new') === -1) {
    tabs.push({
      label: 'Scripts',
      to: (recordId) ? `/dashboard/projects/${recordId}/scripts` : '',
    });

    tabs.push({
      label: 'Media',
      to: (recordId) ? `/dashboard/projects/${recordId}/media` : '',
    });

    tabs.push({
      label: 'Activity',
      to: (recordId) ? `/dashboard/projects/${recordId}/activity` : '',
    });

    if (currentUser?.is_super_admin) {
      tabs.push(
        {
          label: 'Admin',
          to: (recordId) ? `/dashboard/projects/${recordId}/admin` : '/dashboard/projects/:id/admin/new',
        },
      );
    }

    if ( isDevMode ) {
      tabs.push({
        label: 'Orders',
        to: (recordId) ? `/dashboard/projects/${recordId}/orders` : '',
      });
    }
  }

  return tabs;
};
